import { motion } from "framer-motion";
import { Radar, MapPin, Truck, Wrench, Search } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const SERVICES = [
  {
    icon: Radar,
    title: "Monitoramento Ativo",
    desc: "Mapeamento contínuo das áreas de fuga e dos pontos críticos de abandono nas imediações do seu estabelecimento.",
    img: "/assets/operator.jpg",
    span: "lg:col-span-3",
  },
  {
    icon: MapPin,
    title: "Rastreamento Inteligente",
    desc: "Geolocalização e rotas otimizadas para detectar rapidamente carrinhos fora do perímetro da loja.",
    img: "/assets/rastreamento.jpg",
    imgH: "h-36",
    span: "lg:col-span-3",
  },
  {
    icon: Truck,
    title: "Resgate Especializado",
    desc: "Equipes treinadas para recolhimento ético, seguro e em conformidade legal, com devolução imediata ao seu pátio.",
    img: "/assets/van-resgatecar.jpg",
    span: "lg:col-span-2",
  },
  {
    icon: Wrench,
    title: "Assistência Técnica",
    desc: "Higienização, troca de rodas, solda e revitalização completa da frota — do resgate à disponibilidade.",
    img: "/assets/rider.jpg",
    span: "lg:col-span-2",
  },
  {
    icon: Search,
    title: "Prospecção de Ativos",
    desc: "Auditoria de pátio, identificação de lotes extraviados nos bairros vizinhos e regularização do inventário.",
    img: "/assets/prospeccao.jpg",
    span: "lg:col-span-2",
  },
];

export const Services = () => (
  <section id="servicos" className="relative py-24 sm:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-16 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between"
      >
        <div className="max-w-2xl">
          <p className="font-tech text-xs font-bold uppercase tracking-[0.25em] text-[#06B6D4]">Operação completa</p>
          <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
            Cinco frentes. Um único objetivo: <span className="text-[#A3E635]">zero perda.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-slate-400">
          Do primeiro alerta no radar até o carrinho revitalizado de volta ao pátio — cuidamos de todo o ciclo.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-6">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: EASE }}
            className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-[#1B3579] transition-all duration-300 hover:-translate-y-1 hover:border-[#FF5722]/50 hover:shadow-[0_20px_60px_rgba(255,87,34,0.12)] ${s.span}`}
            data-testid={`service-card-${i}`}
          >
            {s.img && (
              <div className={`relative ${s.imgH || "h-44"} overflow-hidden`}>
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1B3579] via-transparent to-transparent" />
              </div>
            )}
            <div className="p-7">
              <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg border border-white/10 bg-[#1E3A8A] text-[#A3E635] transition-colors duration-300 group-hover:border-[#FF5722]/40">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.desc}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
